export const ACCESS_AREAS = [
    { label: 'Dashboard', value: '/dashboard' },
    { label: 'Atendimentos IA', value: '/business-intelligence' },
    { label: 'Cronograma de Envios', value: '/schedule' },
    { label: 'CRM / Vendas', value: '/sales' },
    { label: 'Config. Comerciais', value: '/settings/commercial' },
    { label: 'Implantação', value: '/customer-support' },
    { label: 'Tickets', value: '/tickets' },
    { label: 'Clientes', value: '/clients' },
    { label: 'Usuários', value: '/users' },
    { label: 'Monitoramento', value: '/monitoring' },
    { label: 'Campanhas', value: '/campaigns' },
    { label: 'Relatórios', value: '/reports' },
    { label: 'Configurações', value: '/settings' },
    { label: 'Disparos', value: '/disparos' },
    { label: 'Log de Auditoria', value: '/audit-logs' },
    { label: 'Gestão de Atendimento', value: '/attendances' },
    { label: 'Central de Cobrança', value: '/central-cobranca' },
];
